export const CANDIDATES_SORT_APPLICANTS_SUFFIX = 'submissions'; // Very important to keep this name for testing the dropdown
export const CANDIDATES_SORT_JURY_SUFFIX = 'added'; // Very important to keep this name for testing the dropdown

export const CANDIDATES_SORT_ASC_OPTION = {
  createdAt: { by: 1, name: 'First' },
};
export const CANDIDATES_SORT_DESC_OPTION = {
  createdAt: { by: -1, name: 'Latest' },
};
export const CANDIDATES_SORT_AVG_RATING_DESC_OPTION = {
  averageRating: { by: -1, name: 'Highest avg. score' },
};
export const CANDIDATES_SORT_AVG_RATING_ASC_OPTION = {
  averageRating: { by: 1, name: 'Lowest avg. score' },
};
export const CANDIDATES_SORT_AMOUNT_OF_RATINGS_DESC_OPTION = {
  // Most scores (Candidates with the highest total amount of reviews)
  amountOfRatings: { by: -1, name: 'Most scores' },
};
export const CANDIDATES_SORT_AMOUNT_OF_RATINGS_ASC_OPTION = {
  // Least scores (Candidates with the lowest total amount of reviews)
  amountOfRatings: { by: 1, name: 'Least scores' },
};
export const CANDIDATES_SORT_BUTTON_TEST_ID = 'submissions-sort-button';
export const CANDIDATES_SORT_ASC_OPTION_TEST_ID = 'submissions-sort-asc-option';
export const CANDIDATES_SORT_DESC_OPTION_TEST_ID =
  'submissions-sort-desc-option';
export const CANDIDATES_SORT_AVG_RATING_ASC_OPTION_TEST_ID =
  'submissions-sort-avg-rating-asc-option';
export const CANDIDATES_SORT_AVG_RATING_DESC_OPTION_TEST_ID =
  'submissions-sort-avg-rating-desc-option';
export const CANDIDATES_SORT_AMOUNT_OF_RATINGS_DESC_OPTION_TEST_ID =
  'submissions-sort-amount-of-ratings-desc-option';
export const CANDIDATES_SORT_AMOUNT_OF_RATINGS_ASC_OPTION_TEST_ID =
  'submissions-sort-amount-of-ratings-asc-option';

export const CANDIDATES_SORT_OPTIONS = [
  {
    testId: CANDIDATES_SORT_ASC_OPTION_TEST_ID,
    option: CANDIDATES_SORT_ASC_OPTION,
    isApplicantsStage: true,
    isJuryStage: true,
    isFinalistsStage: true,
    label: 'First',
    needSuffix: true,
  },
  {
    testId: CANDIDATES_SORT_DESC_OPTION_TEST_ID,
    option: CANDIDATES_SORT_DESC_OPTION,
    isApplicantsStage: true,
    isJuryStage: true,
    isFinalistsStage: true,
    label: 'Latest',
    needSuffix: true,
  },
  {
    testId: CANDIDATES_SORT_AVG_RATING_ASC_OPTION_TEST_ID,
    option: CANDIDATES_SORT_AVG_RATING_ASC_OPTION,
    isApplicantsStage: false,
    isJuryStage: false,
    isFinalistsStage: true,
    label: 'Lowest avg. score',
    needSuffix: false,
  },
  {
    testId: CANDIDATES_SORT_AVG_RATING_DESC_OPTION_TEST_ID,
    option: CANDIDATES_SORT_AVG_RATING_DESC_OPTION,
    isApplicantsStage: false,
    isJuryStage: false,
    isFinalistsStage: true,
    label: 'Highest avg. score',
    needSuffix: false,
  },
  {
    testId: CANDIDATES_SORT_AMOUNT_OF_RATINGS_DESC_OPTION_TEST_ID,
    option: CANDIDATES_SORT_AMOUNT_OF_RATINGS_DESC_OPTION,
    isApplicantsStage: false,
    isJuryStage: false,
    isFinalistsStage: true,
    label: 'Most scores',
    needSuffix: false,
  },
  {
    testId: CANDIDATES_SORT_AMOUNT_OF_RATINGS_ASC_OPTION_TEST_ID,
    option: CANDIDATES_SORT_AMOUNT_OF_RATINGS_ASC_OPTION,
    isApplicantsStage: false,
    isJuryStage: false,
    isFinalistsStage: true,
    label: 'Least scores',
    needSuffix: false,
  },
];
